import i18n from '_/i18n';

import {ActiveState} from './ActiveFilter.types';

export const ActiveFilterTranslation: Record<ActiveState, string> = {
  ALL: i18n.t('common:activeFilter.activeState.all'),
  ACTIVE: i18n.t('common:activeFilter.activeState.active'),
  INACTIVE: i18n.t('common:activeFilter.activeState.inactive'),
};

export const activeStateItems: {value: ActiveState; label: string}[] = [
  {
    value: 'ALL',
    label: ActiveFilterTranslation.ALL,
  },
  {
    value: 'ACTIVE',
    label: ActiveFilterTranslation.ACTIVE,
  },
  {
    value: 'INACTIVE',
    label: ActiveFilterTranslation.INACTIVE,
  },
];
